import { render, staticRenderFns } from "./PotvrdaStavkiRezervnihDelova.vue?vue&type=template&id=06245b70&"
import script from "./PotvrdaStavkiRezervnihDelova.vue?vue&type=script&lang=ts&"
export * from "./PotvrdaStavkiRezervnihDelova.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports